/* 
* <license header>
*/

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import ReactDOM from 'react-dom'

import Runtime, { init } from '@adobe/exc-app'

import App from './components/App'
import './index.css'

window.React = require('react')

/* Expose global initialization function for external embedding (e.g., Magento) */
window.initPrescriptionApp = function(containerId, config = {}) {
  const container = document.getElementById(containerId || 'root')
  if (!container) {
    return
  }

  const mockRuntime = { on: () => {} }
  // const mockIms = config.ims || {}
   const isEmpty = (obj) =>
    obj && Object.keys(obj).length === 0 && obj.constructor === Object;

    const mockIms =
      !config.ims || isEmpty(config.ims)
        ? {
            profile: {},
            org: {},
            token: {}
          }
        : config.ims;

    const accessToken = Object.prototype.hasOwnProperty.call(config, 'accessToken') 
        ? config.accessToken : ''
        
    const email = Object.prototype.hasOwnProperty.call(config, 'email') 
        ? config.email : ''

    const quoteId = window.prescriptionAppConfig?.quoteId ?? '';

    const quoteSkus = window.prescriptionAppConfig?.quoteSkus ?? '';

    // console.log('Quote Id from APp builder' , quoteId  || '(empty)');
    // console.log('Quote Signature from APp builder' , quoteSkus  || '(empty)');

  ReactDOM.render(
    <App runtime={mockRuntime} ims={mockIms} accessToken={accessToken} email={email} quoteId={quoteId} quoteSkus={quoteSkus} />,
    container
  )
}

/* Here you can bootstrap your application and configure the integration with the Adobe Experience Cloud Shell */
try {
  require('./exc-runtime')
  init(bootstrapInExcShell)
} catch (e) {
  bootstrapRaw()
}

function bootstrapRaw () {
  const mockRuntime = { on: () => {} }
  const mockIms = {profile: {},
          org: {},
          token: {}}

  // console.log('BootstrapRaw runtime:', mockRuntime)
  // console.log('BootstrapRaw ims:', mockIms)

  ReactDOM.render(
    <App runtime={mockRuntime} ims={mockIms}  />,
    document.getElementById('root')
  )
}

function bootstrapInExcShell () {
  const runtime = Runtime()

  // console.log('PrescriptionApp:bootstrapInExcShell runtime object created:', runtime)

  runtime.on('ready', ({ imsOrg, imsToken, imsProfile, locale }) => {
    runtime.done()

    const ims = {
      profile: imsProfile,
      org: imsOrg,
      token: imsToken
    }

  
    // console.log('bootstrapInExcShell runtime running:', runtime)
    // console.log('bootstrapInExcShell ims:', ims)

    ReactDOM.render(
      <App runtime={runtime} ims={ims} />,
      document.getElementById('root')
    )
  })

  // set solution info, shortTitle is used when window is too small to display full title
  runtime.solution = {
    icon: 'AdobeExperienceCloud',
    title: 'PrescriptionIntake',
    shortTitle: 'JGR'
  }

  runtime.title = 'PrescriptionIntake'
}